import { DEF_HEADER_BRIDGE_CONF } from '@/config/config';
import { updateHelpCenter } from '@/services/header-service';

class NplSearchResultInitService {
    updatePageSetting() {
        window.$bridge.store.batchWrite([], draft => {
            draft.headerConfig = {
                ...DEF_HEADER_BRIDGE_CONF.NPL
            };
        });

        updateHelpCenter({
            module: 'next',
        });
    }
}

const nplSearchResultInitInstance = new NplSearchResultInitService();

export default nplSearchResultInitInstance;
